import React from 'react';
import { format, addMonths, subMonths, startOfMonth } from 'date-fns';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface MonthNavigationProps {
  currentDate: Date;
  onDateChange: (date: Date) => void;
  userRegistrationDate?: string;
}

const MonthNavigation: React.FC<MonthNavigationProps> = ({
  currentDate,
  onDateChange,
  userRegistrationDate,
}) => {
  // Calculate navigation limits
  const today = new Date();
  const currentMonth = startOfMonth(currentDate);
  const presentMonth = startOfMonth(today);
  const registrationMonth = userRegistrationDate ? startOfMonth(new Date(userRegistrationDate)) : null;

  // Check if navigation buttons should be disabled
  const canGoToPrevious = !registrationMonth || currentMonth > registrationMonth;
  const canGoToNext = currentMonth < presentMonth;

  const goToPreviousMonth = () => {
    if (canGoToPrevious) {
      onDateChange(subMonths(currentDate, 1));
    }
  };

  const goToNextMonth = () => {
    if (canGoToNext) {
      onDateChange(addMonths(currentDate, 1));
    }
  };

  const goToToday = () => {
    onDateChange(today);
  };

  const monthYear = format(currentDate, 'MMMM yyyy');
  const isCurrentMonth = format(currentDate, 'yyyy-MM') === format(today, 'yyyy-MM');

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={goToPreviousMonth}
            disabled={!canGoToPrevious}
            className="h-8 w-8 p-0"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          
          <h2 className="text-xl font-semibold min-w-[180px] text-center">
            {monthYear}
          </h2>
          
          <Button
            variant="outline"
            size="sm"
            onClick={goToNextMonth}
            disabled={!canGoToNext}
            className="h-8 w-8 p-0"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {!isCurrentMonth && (
        <Button
          variant="outline"
          size="sm"
          onClick={goToToday}
        >
          Today
        </Button>
      )}
    </div>
  );
};

export default MonthNavigation;